/* eslint-disable indent */
import styled from 'styled-components';
import { Grid, Cell } from '@carvana/showroom-grid';
import { getMediaQuery } from '@carvana/showroom-theme';
import { Section, InnerSection } from '../../../styles/section/section';

export const SectionWrapper = styled(Section)`
  padding-top: 4.0625rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    padding-top: 3.75rem;
  }
`;

export const InnerSectionWrapper = styled(InnerSection)`
  padding-top: 1.5rem;
`;

export const ArticleWrapper = styled(Grid).attrs({ gap: { xs: 0, lg: 16 } })``;

export const CellWrapper = styled(Cell).attrs({ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 })`
  border-bottom: 1px solid ${(props) => props.theme.color.neutral.v300};
  padding: 1rem 0;

  ${(props) => props.showBottomBorder && 'border-bottom: 0'};

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    padding: 0 1.75rem 0 !important;
    border-right: 1px solid ${(props) => props.theme.color.neutral.v300};
    border-bottom: 0;

    &:nth-child(3) {
      border-right: 0;
    }
  }
`;

export const SmallSeparator = styled.hr`
  border: 0;
  clear: both;
  display: block;
  width: 90%;
  background-color: ${(props) => props.theme.color.neutral.v300};
  height: 1px;
  margin: 0 auto 1rem;
  visibility: hidden;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    margin: 2rem auto;
    visibility: visible;
  }
`;

export const ArticleHeader = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 700;
  text-transform: uppercase;
  padding-bottom: 1rem;
`;

// export const Article = styled(Cell).attrs({ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 })`
export const Article = styled.div`
  padding-bottom: 1.2rem;
  line-height: 20px;
  padding-right: 1rem;
`;

export const ShowAllButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.primary.v200};
`;

export const ShowAllButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.primary.v200};
  font-weight: 700;
  cursor: pointer;
`;

export const Caret = styled.div`
  position: relative;
  top: -3px;
  margin-left: 1rem;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;

    ${(props) =>
      props.down
        ? `border-top: 6px solid ${props.theme.color.primary.v200}`
        : `border-bottom: 6px solid ${props.theme.color.primary.v200}`};
  }

  &:after {
    content: '';
    position: absolute;
    left: 5px;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    ${(props) =>
      props.down
        ? `border-top: 1px solid ${props.theme.color.primary.v200}`
        : `border-bottom: 1px solid ${props.theme.color.primary.v200}`};
    ${(props) => (props.down ? 'top: 0' : 'top: 5px')};
  }
`;
